export enum OperationType {
    Open = 1,
    Close = 2,
    Approved = 3,
    Rejected = 4
}